import React from "react";
import NavBar from "../components/NavBar";
import ParentFeedbackComponent from "../components/ParentFeedbackComponent";
import Footer from "../components/Footer";

    const ParentFeedback =() => {
        return(
            <div className="main-container">
                <NavBar/>
                <ParentFeedbackComponent/>
                <Footer/>
            </div>
        )
    }
    export default ParentFeedback